module.exports = __webpack_public_path__ + "static/img/image_shangpiao@2x.8e2b939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/image_shangpiao@2x.png
// module id = V32J
// module chunks = 69